import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-12 md:py-16 lg:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm font-medium mb-3">
            <i className="ri-chat-3-line"></i>
            <span>读者声音</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            读者热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
            来自韩漫、日漫、国漫读者的真实评价，分享他们在香蕉漫画网的阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-300 transition-all"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="img-container w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      const container = e.currentTarget.closest('.img-container');
                      if (container) container.classList.add('hidden');
                    }}
                  />
                </div>
                <div>
                  <h3 className="font-heading text-sm font-semibold text-foreground-900">{comment.name}</h3>
                  <div className="flex items-center gap-1">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${
                          i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-background-400'
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3">
                {comment.content}
              </p>
              <div className="text-xs text-foreground-400">{comment.date}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}